// turnstile-gate.js
// DG_TURNSTILE_OPTIONAL_GLOBAL_GATE_FORM_PROTECTION_V1
// Cloudflare Turnstile gating logic for Shopify theme
// Move all inline JS from theme.liquid here to comply with Shopify CSP

document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function() {
  var config = window.turnstileThemeConfig || {};
  var gate = document.getElementById('TurnstileGate');
  var widget = document.getElementById('TurnstileWidget');
  var status = document.getElementById('TurnstileStatus');
  var storageKey = config.storageKey || 'turnstile_theme_passed';
  var siteKey = config.siteKey;
  var workerUrl = config.workerUrl;
  var designMode = Boolean(config.designMode || window.Shopify && window.Shopify.designMode);

  if (!siteKey) {
    return;
  }

  function unlockGate() {
    if (gate) gate.hidden = true;
    document.body.classList.remove('turnstile-locked');
    if (status) status.textContent = '';
  }

  function lockGate() {
    if (!gate) return;
    gate.hidden = false;
    document.body.classList.add('turnstile-locked');
  }

  function passedAlready() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberPass() {
    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {}
  }

  if (designMode) {
    unlockGate();
    return;
  }

  function verifyTokenWithWorker(token) {
    if (!workerUrl) {
      return Promise.resolve(true);
    }
    return window.fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: token })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function(result) {
        return Boolean(result.ok && result.data && result.data.success);
      })
      .catch(function() {
        return false;
      });
  }

  function getTargetForms() {
    return document.querySelectorAll([
      'form[action*="/contact"]',
      'form[action*="/cart/add"]',
      'form[action="/cart"]',
      // 'form[action*="/account"]', // Removed to avoid interfering with Shopify login
      'form[id*="newsletter"]',
      'form[class*="newsletter"]'
    ].join(','));
  }

  function findSubmitTarget(form) {
    return form.querySelector('button[type="submit"], input[type="submit"], button[name="add"], button');
  }

  function ensureFormWidget(form) {
    if (form.dataset.turnstileBound === 'true') {
      return;
    }
    var wrapper = form.querySelector('.turnstile-inline');
    var widgetTarget;
    var statusTarget;
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'turnstile-inline';
      widgetTarget = document.createElement('div');
      widgetTarget.className = 'turnstile-inline__widget';
      statusTarget = document.createElement('div');
      statusTarget.className = 'turnstile-inline__status';
      wrapper.appendChild(widgetTarget);
      wrapper.appendChild(statusTarget);
      var submitTarget = findSubmitTarget(form);
      if (submitTarget && submitTarget.parentNode) {
        submitTarget.parentNode.insertBefore(wrapper, submitTarget);
      } else {
        form.appendChild(wrapper);
      }
    } else {
      widgetTarget = wrapper.querySelector('.turnstile-inline__widget');
      statusTarget = wrapper.querySelector('.turnstile-inline__status');
    }
    if (!window.turnstile) {
      statusTarget.textContent = 'Loading security check...';
      window.setTimeout(function() {
        if (form.dataset.turnstileBound !== 'true') {
          ensureFormWidget(form);
        }
      }, 250);
      return;
    }
    form.dataset.turnstileBound = 'true';
    var formToken = '';
    var verifiedWithWorker = false;
    var isSubmitting = false;
    window.turnstile.render(widgetTarget, {
      sitekey: siteKey,
      callback: function(token) {
        formToken = token;
        verifiedWithWorker = false;
        statusTarget.textContent = '';
      },
      'expired-callback': function() {
        formToken = '';
        verifiedWithWorker = false;
        statusTarget.textContent = 'Security check expired. Please try again.';
      },
      'error-callback': function() {
        formToken = '';
        verifiedWithWorker = false;
        statusTarget.textContent = 'Security check failed to load. Refresh and try again.';
      }
    });
    form.addEventListener('submit', function(event) {
      if (passedAlready()) {
        return;
      }
      if (!formToken) {
        event.preventDefault();
        statusTarget.textContent = 'Please complete the security check before submitting.';
        return;
      }
      if (!workerUrl || verifiedWithWorker || isSubmitting) {
        return;
      }
      event.preventDefault();
      isSubmitting = true;
      statusTarget.textContent = 'Verifying security check...';
      verifyTokenWithWorker(formToken).then(function(success) {
        isSubmitting = false;
        if (!success) {
          formToken = '';
          verifiedWithWorker = false;
          statusTarget.textContent = 'Verification failed. Please try again.';
          return;
        }
        verifiedWithWorker = true;
        statusTarget.textContent = '';
        form.requestSubmit();
      });
    });
  }

  function activateFormProtection(form) {
    if (passedAlready() || form.dataset.turnstileActivated === 'true') {
      return;
    }
    form.dataset.turnstileActivated = 'true';
    form.addEventListener('focusin', function onFocusIn() {
      ensureFormWidget(form);
    });
    form.addEventListener('pointerdown', function onPointerDown() {
      ensureFormWidget(form);
    }, { passive: true });
    form.addEventListener('submit', function onSubmit(event) {
      if (form.dataset.turnstileBound === 'true' || passedAlready()) {
        return;
      }
      event.preventDefault();
      ensureFormWidget(form);
    });
  }

  function bindFormWidgets() {
    if (passedAlready()) {
      return;
    }
    getTargetForms().forEach(function(form) {
      activateFormProtection(form);
    });
  }

  function renderGate() {
    if (!window.turnstile) {
      window.setTimeout(renderGate, 250);
      return;
    }
    window.turnstile.render(widget, {
      sitekey: siteKey,
      callback: function() {
        rememberPass();
        unlockGate();
      },
      'expired-callback': function() {
        status.textContent = 'Security check expired. Please try again.';
        lockGate();
      },
      'error-callback': function() {
        status.textContent = 'Security check failed to load. Refresh and try again.';
        lockGate();
      }
    });
  }

  bindFormWidgets();
  if (passedAlready()) {
    unlockGate();
    return;
  }
  if (gate && widget && status) {
    lockGate();
    renderGate();
  }
});
